import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import Grid from "@material-ui/core/Grid";
import axios from "axios";

import { makeStyles } from "@material-ui/core/styles";

//Custom Components
import ChartCard from "../../components/Cards/ChartCard";
import CardSwitch from "../../components/Cards/CardSwitch";
import CardTable from "../../components/Cards/CardTable";
import { Wrapper } from "../../components";
import Loader from "../../components/Loader/Loader";

//MockData
import stateConfig from "./stateConfig";
import { STATE_ID_STATISTICS_BASE_URL } from "../../constants";

//Icons
import { ReactComponent as Canton } from "../../img/icons/2_Canton.svg";
import { ReactComponent as Tabla } from "../../img/icons/2_Tabla.svg";

const useStyles = makeStyles((theme) => ({
  innerGrid: {
    position: "relative",
  },
  barContainer: {
    position: "relative",
    width: "100%",
    height: "55vh",
    [theme.breakpoints.down("lg")]: {
      height: "55vh",
    },
    [theme.breakpoints.down("xs")]: {
      width: (loading) => (loading ? "100%" : "165vh"),
    },
  },
}));

const State = (props) => {
  const { stateName, stateId, year, campaign } = props;

  const APIURL = `${STATE_ID_STATISTICS_BASE_URL}campaignId=${campaign}&stateId=${stateId}`;

  const [visible, setVisible] = useState("left");
  const [homeData, setHomeData] = useState(null);
  const [, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const classes = useStyles(loading);

  async function getData() {
    try {
      setLoading(true);
      const homeData = await axios.get(APIURL).then((data) => {
        return data.data;
      });
      setHomeData(homeData);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleVisible = (newVisible) => {
    setVisible(newVisible);
    getData();
  };

  const sortedData = homeData?  homeData.sort(function (a, b) {
    return parseFloat(b.totalPeople) - parseFloat(a.totalPeople);
  }) : null;

  const totalPeopleArray = sortedData
    ? homeData.map((data) => data.totalPeople)
    : [];
  const labels = sortedData
    ? homeData.map((data) => data.firstPoliticalDivition.name)
    : [];

  const stateConfigData = stateConfig(labels, totalPeopleArray);
  const dataTableInfo = sortedData
    ? homeData.map((data) => ({
        name: data.firstPoliticalDivition.name,
        total: data.totalPeople,
      }))
    : [];

  return (
    <Wrapper>
      <Grid container spacing={1} justify="center">
        <Grid className={classes.innerGrid} item xs={12} sm={10} md={10}>
          <CardSwitch sendData={handleVisible}>
            <Canton />
            <Tabla />
          </CardSwitch>
          {visible === "left" && (
            <ChartCard
              title={stateName}
              subheader={"Total de personas evacuadas por cantón"}
              icono={props.children}
              padding={"14px"}
              year={year}
            >
              {stateConfigData.type === "bar" && (
                <div className={classes.barContainer}>
                  {loading ? (
                    <Loader />
                  ) : (
                    <Bar
                      data={stateConfigData.data}
                      height={stateConfigData.height}
                      options={stateConfigData.options}
                    />
                  )}
                </div>
              )}
            </ChartCard>
          )}
          {visible === "right" && (
            <ChartCard
              icono={props.children}
              title={stateName}
              subheader={"Total de personas evacuadas por cantón"}
              year={year}
            >
              {loading ? <Loader /> : <CardTable data={dataTableInfo} />}
            </ChartCard>
          )}
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default State;
